export default __webpack_public_path__ + "static/media/puzzel2.e1fb3994.png";